
import { useEffect } from "react";
import { Footer } from "../../layout/Footer/Footer"
import { getImageUrl } from "../../utils/images"



export const FormSubmittedPage = ({appId}) => {

     useEffect(() => {
    if (localStorage.getItem("token")) {
      localStorage.removeItem("token");
    }

    if (localStorage.getItem("tr")) {
      localStorage.removeItem("tr");
    }
  }, []);
     
    return (
        <div className="container-fluid">
            
            
            <div className="row">
                <div className="col-12 col-md-12 px-0">
                    <div className="left-title-bg">
                  
                        <p className="left-title">Thank you</p>
                    </div>
                    <div className="content confirmation">
                        <div className="mb-40">
                            <a href="#">
                                <img
                                    src={getImageUrl("logo-dark.svg")}
                                    alt="img"
                                    className="w-200p"
                                />
                            </a>
                        </div>
                     
          
                <span>
                  <div className=''>
                  <img
                        src={getImageUrl('icon-arrow-backspace.svg')}
                        alt='img'
                        className='mr-5 left-arrow'
                      />
    <a
  onClick={() => {

    window.location.href = `${window.location.origin}/login-page`;
  }}
  className="text-light-default font-weight-600 cursor-pointer"
>
  Back to login
</a>
                  </div>
                </span>
          
           
                        <p className="mb-0 font-20 font-md-30 font-weight-800">THANK YOU !!</p>
                        <p className="d-flex">
                          Your application tracking number#
                            <br />
                            <span className="text-default font-weight-600 mx-10">{appId}</span>
                        </p>
                        <div className="row">
                            <div className="col-12 col-md-8">
                                <p className="opacity-70">
                                    Your application has been successfully received, and we are in the
                                    process of reviewing the details you provided. Our team is
                                    dedicated to ensuring a smooth onboarding experience for our
                                    partners, and we will do our best to expedite this process.
                                </p>
                                <p className="font-weight-700 opacity-70">
                                    Here's an overview of what to expect next:
                                </p>
                               
                                <ul className="list-unstyled conf-list">
                                    <li className="checked">Submitted</li>
                                    <li className="unchecked">Under Review</li>
                                    {!(localStorage.getItem("isAuditFlag")==="true") && <li className="unchecked">Agreement</li>}
                                    <li className="unchecked">Onboarding</li>
                                </ul>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>


        </div>

    )
}